import React from 'react'
import { constructUrl } from '../../../services/common'
import { icon } from '../../../services/icon'
import { Parser } from '../../common'
import Link from '../link/Link'

const File = ({ block, parent }) => {
    return parent !== 'Groupe' ? (
        <Link
            className={'block-file '}
            url={constructUrl(block?.attributes.ID, block?.attributes?.audience)}
        >
            <span>{icon('arrow-right')}</span>
            {block.content && <span>{block?.content}</span>}
            {block.childrens && (
                <span>
                    <Parser content_block={block.childrens} />
                </span>
            )}
        </Link>
    ) : (
        <>
            {block.content && <p>{block?.content}</p>}
            {block.childrens && <Parser content_block={block.childrens} />}
        </>
    )
}

export default File
